import { render } from "./dashboard-page.vue?vue&type=template&id=e12aa7de"
import script from "./dashboard-page.js?vue&type=script&lang=js&external"
export * from "./dashboard-page.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__